// error-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
@Component({
  selector: 'app-error-dialog',
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title class="text-xl font-semibold text-red-600">Form Submission Error</h2>
    <mat-dialog-content class="pt-2">
      <p class="mb-3">{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="pt-3">
      <button mat-flat-button color="warn" mat-dialog-close>OK</button>
    </mat-dialog-actions>
    
  `
})
export class ErrorDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {}
}
